import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import Reveal from '../common/Reveal';

// Real equipment brands, verified against actual installation posts on JSISCO's Facebook page.
export const BRANDS = [
  { name: 'Huawei',      logo: '/logos/vendors/huawei.png',   dark: true },
  { name: 'Jinko Solar', logo: '/logos/vendors/jinko.png' },
  { name: 'Seraphim',    logo: '/logos/vendors/seraphim.png' },
  { name: 'LONGi',       logo: '/logos/vendors/longi.png' },
  { name: 'JA Solar',    logo: '/logos/vendors/ja-solar.png' },
];

const Partners = () => {
  const { t } = useLanguage();

  return (
    <section className="py-12 bg-white dark:bg-gray-950 border-y border-gray-100 dark:border-gray-800">
      <div className="container mx-auto px-4">
        <Reveal>
          <div className="flex justify-center mb-8">
            <Link to="/sustainability"
              className="inline-flex items-center gap-4 ps-3 pe-7 py-3 rounded-full border border-secondary-200 dark:border-secondary-800 bg-secondary-50 dark:bg-secondary-900/20 hover:bg-secondary-100 dark:hover:bg-secondary-900/40 transition">
              <img src="/logos/partners/maan-municipality.png" alt={t('partners.maan.name')} width="96" height="96" className="w-24 h-24 object-contain rounded-full bg-white" />
              <span className="text-base font-semibold text-secondary-700 dark:text-secondary-400">
                {t('partners.strategicTitle')}: {t('partners.maan.name')}
              </span>
            </Link>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <p className="text-center text-xs font-semibold tracking-widest text-gray-500 dark:text-gray-400 uppercase mb-8">
            {t('partners.suppliersTitle')}
          </p>
        </Reveal>

        <div className="flex flex-wrap items-center justify-center gap-4">
          {BRANDS.map((brand, i) => (
            <Reveal key={brand.name} delay={i * 80}>
              <div className={`h-14 px-6 rounded-xl flex items-center justify-center transition-transform duration-300 hover:-translate-y-0.5 ${
                brand.dark ? 'bg-primary-950' : 'bg-white border border-gray-100 shadow-sm'
              }`}>
                <img src={brand.logo} alt={brand.name} width="110" height="24" className="h-6 max-w-[110px] object-contain" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
